<template>
  <div>
    {{ departure }}
  </div>
</template>

<script>
import {formatDT} from '../utils'

export default {
  name: 'CalcFlightsTableCellDeparture',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    departure () {
      return formatDT(this.row.departure)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcFlightsTableCellDeparture.vue